module.exports = __webpack_public_path__ + "img/logo-BTC-tmp.bf7f105b.svg";